export default {
  headings: {
    setting: "تنظیمات",
    sidebarColor: "رنگ سایدبار",
    navbar: "هدر ثابت",
    theme: "روشن / تیره",
    signIn: "ورود به عرش",
    signUp: "ثبت نام در عرش",
    rule: "قوانین و مقررات",
    arshId: "عرش Id شما :",
    workspace: "فضای کاری : ",
    userInfo: "اطلاعات کاربری",
    oAuth: "احراز هویت دو مرحله ای",
    devices: "دستگاه ها",
    requests: "درخواست ها",
    request:'درخواست',
    footer:'کلیه‌ی حقوق این سایت متعلق به شرکت عمید رایانه شریف(عرش) می‌باشد',
    today:'امروز:'
  },
  captions: {
    setting: " تم دلخواه خود راانتخاب کنید",
    rememberMe: "مرا به یاد آور",
    noAccount: "اکانت ندارید ؟",
    signUp: "برای ثبت نام ایمیل و پسورد خود را وارد کنید",
    aggrement: "من شرایط و مقررات را می پذیرم",
    hasAccount: "اکانت دارید ؟",
    oAuthDesc:
      "احراز هویت دو مرحله ای یک لایه به امنیت حساب کاربری شما اضافه می کند. برای اینکار به چیزی بیشتر از رمز عبور برای ورود به حساب کاربری نیاز دارید.",
    safty:
      "شما می توانید برای امنیت و بازیابی رمز عبور خود ، آدرس پست الکترونیکی پشتیبان خود را وارد کنید.",
    userInfo: "در این بخش می توانید اطلاعات کاربری خود را در عرش مدیریت کنید",
    requests:'در این بخش می توانید وضعیت درخواست های خود را مشاهده کنید و قبل از تایید و اعمال ادمین درخواست خود را لغو کنید.'
  },
  messages: {
    requiredPass: "پسورد الزامی است",
    requiredPhone: "شماره همراه الزامی است",
  },
  options: {},
  placeholders: {},
  buttons: {
    alreadySign: "قبلا ثبت نام کردم",
    signIn: "ورود",
    signUp: "می خوام ثبت نام کنم",
    forget: "رمز عبور را فراموش کردم",
    guide: "راهنمایی",
    rule: "قوانین و مقررات",
    next: "مرحله بعدی",
    changeNumber: "تغییر شماره همراه",
    resend: "ارسال مجدد",
    agree: "موافقم",
    cancel: "انصراف",
    changePassword: "تغییر رمز عبور",
    confirm: "تایید",
    activate: "فعال سازی",
    hamahang:'هماهنگ',
    ganje:'گنجه',
    simap:'سیماپ',
    tele:'تلوبیون',
    addAccount:'افزودن اکانت دیگر',
    exit:'خروج از سیستم',
    privacy:'حریم خصوصی',
    guide:'راهنمایی',
    sendComment:'ارسال نظر',
    action:'اعمال تغییرات',
    register:'ثبت',
    sendCode:'ارسال کد',
    back:'بازگشت',
    newAccount:'حساب جدید',
    saveAndContinue:'ذخیره و ادامه'
  },
  tooltip: {
    messages: "پیام های جدید خود را بررسی کنید",
  },
  log: {},
  labels: {
    userName:'نام کاربری',
    search: "جستجو",
    email: "پست الکترونیکی پشتیبان",
    password: "رمز عبور",
    reapetPass: "تکرار رمز عبور",
    name: "نام ",
    family: "نام خانوادگی",
    phone: "شماره همراه",
    birthDate: "تاریخ تولد",
    gender: "جنسیت :",
    completeName: "نام کامل",
    oldPass: "رمز عبور قبلی",
    newPass: "رمز عبور جدید",
    presentPass: "رمز عبور فعلی",
    reapetNewPass: "تکرار رمز عبور جدید",
    useEmail: "استفاده از ایمیل",
    usePhone: "استفاده از شماره همراه",
    reqTitle:'عنوان درخواست',
    reqDes:'متن درخواست'
  },
};
